import { createContext } from 'react';

import type { CustomerProfile } from './api/account';

export type CustomerAuthStatus = 'loading' | 'authenticated' | 'anonymous';

export interface CustomerAuthContextValue {
  status: CustomerAuthStatus;
  customer: CustomerProfile | null;
  signIn: (email: string, password: string, captchaToken?: string) => Promise<void>;
  /**
   * End the session. `leaving` says the shopper chose to and is already on
   * their way somewhere else, so the account guard should not send them to
   * the sign-in form in the meantime.
   */
  signOut: (options?: { leaving?: boolean }) => Promise<void>;
  /** True from a shopper's own sign-out until they land on the next page. */
  leaving: boolean;
  /** Re-read the profile after the shopper edits it. */
  reload: () => Promise<void>;
}

/** Kept apart from the provider so the provider file only exports components. */
export const CustomerAuthContext = createContext<CustomerAuthContextValue | null>(null);
